import React, { useState } from 'react';
import moment from 'moment';


export const TimeSelect = ({timeCS, toggleSelectTimeCS, onSelectTimeCSChange,listMonths}) => {
    // const [isSelectTime, setToggleSelect] = useState(false);


    const showTimeSelect = () => {
        toggleSelectTimeCS()
    }

    const onSelect = (e) => {

        onSelectTimeCSChange(e); 
        // if (timeCS > 0) {
        //     showTimeSelect()
        // }
    }


    return (
       		<div className="content">
              <p className="fontWeight-8">Gói thuê</p>
              <div className="content-box month-place" >
              {listMonths && listMonths.map((time, i) => { return <div className="custom-radio" key={i}> 
                    <input type="radio" id={`r${time}`} name={'rTimeSelect'} value={time}  checked={timeCS == time} onChange={(e) => onSelect(e)}/>
                    <label htmlFor={`r${time}`}>
                      <p className="text-ct">{time} tháng </p>
                    </label>
                  </div>}
                )
              }
            </div>
        </div>
   
    )
}

{/* <div className="choose-item has-arrow" ref={wrapperCSSelect}>
<p className="select" onClick={toggleSelectTimeCS}>{`${timeCS} tháng`}</p> */}
  
// <div className="custom-radio" key={i}>
//     <input type="radio" id={`r${time}`} name={'rTimeSelect'} value={time} checked={timeCS == time} onChange={(e) => onSelect(e)} />
//     <label htmlFor={`r${time}`}>{time} tháng</label>
// </div>
// getBTimes().map((time, i) => <div className="custom-radio" key={i}>
//         <input type="radio" id={`${id ? id : 'r'}${time.value}`} name={id ? id : 'rTimeSelect'} value={time.value} checked={timeCS == time.value} onChange={(e) => onSelect(e)} />
//         <label htmlFor={`${id ? id : 'r'}${time.value}`}>{time.label}</label>
//      </div>
// )

{/* <div className="content"> 
<p className="fontWeight-8">Thời gian thuê</p>
<div className="content-box month-place"> 
  <div className="custom-radio"> 
    <input type="radio" id="radio40" name="radio-timeee0" defaultChecked />
    <label htmlFor="radio40">
      <p className="text-ct">1 tháng </p>
    </label>
  </div>
  <div className="custom-radio"> 
    <input type="radio" id="radio41" name="radio-timeee0" />
    <label htmlFor="radio41">
      <p className="text-ct">3 tháng </p>
    </label>
  </div>
  <div className="custom-radio"> 
    <input type="radio" id="radio42" name="radio-timeee0" />
    <label htmlFor="radio42">
      <p className="text-ct">6 tháng </p>
    </label>
  </div>
  <div className="custom-radio"> 
    <input type="radio" id="radio43" name="radio-timeee0" />
    <label htmlFor="radio43">
      <p className="text-ct">9 tháng</p>
    </label>
  </div>
  <div className="custom-radio"> 
    <input type="radio" id="radio44" name="radio-timeee0" />
    <label htmlFor="radio44">
      <p className="text-ct">12 tháng</p>
    </label>
  </div>
</div>
</div> */}